import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Foot from '../../../components/footer';
import GrHeader from '../../../components/grHeader';
import Qrcode from '../../../components/qrcode';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
/**
 * for this page
 */
const setpage = new Image();
const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            qrClass: true, // 二维码样式名,true为当前样式
            qrDisplay: false, // 二维码是否显示
            scrollTop: true, // 定位页面上部分
            scrollMid: false, // 定位页面中部
            scrollBottom: false, // 定位页面底部
            staPageSrc: '',
        };
        componentDidMount() {
            // window.addEventListener('resize', this.onWindowResize);
            window.addEventListener('scroll', this.onWindowScroll);
            const time = new Date().getTime();
            const stasrc = `http://sapp.d.ifeng.com/stat.html?site=campusrecruitment&dtfrom=load&dateline=${time}`;

            setpage.src = stasrc;
            console.log('loadsrc==', stasrc);
        }
        componentWillUnmount() {
            // window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('scroll', this.onWindowScroll);
        }

        // 页面滚动定位
        onWindowScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            // console.log('top==', scrollTop);
            if (scrollTop >= 0 && scrollTop <= 768) {
                this.setState({
                    scrollTop: true,
                    scrollMid: false,
                    scrollBottom: false,
                });
            }
            if (scrollTop >= 768 && scrollTop <= 1470) {
                this.setState({
                    scrollTop: false,
                    scrollMid: true,
                    scrollBottom: false,
                });
            }
            if (scrollTop >= 1470) {
                this.setState({
                    scrollTop: false,
                    scrollMid: false,
                    scrollBottom: true,
                });
            }
        };

        // 点击右侧定位li
        handleFixScroll = num => {
            window.scroll(0, num);
        };

        // 改变统计地址
        handleChangeStasrc = src => {
            const time = new Date().getTime();
            const staSrc = `http://sapp.d.ifeng.com/stat.html?site=campusrecruitment&dtfrom=${src}&dateline=${time}`;

            console.log('srcnew==', staSrc);

            setpage.src = staSrc;
        };

        render() {
            const { content } = this.props;
            const { header, qrCodeInfo, nav, imageInfo } = content;
            const { qrClass, qrDisplay, scrollTop, scrollMid, scrollBottom } = this.state;

            return (
                <div>
                    <div className={styles.col}>
                        <Chip id="110041" type="struct" title="公用头部" groupName="校招首页" content={header}>
                            <GrHeader current={0} />
                        </Chip>
                        <Chip id="110042" type="struct" title="跳转链接" groupName="校招首页" />
                        <div className={styles.colbox}>
                            <div id="fullpage">
                                <div className={`${styles.section} ${styles.sec01}`} id="sec01">
                                    <img
                                        src="http://p2.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_01.png"
                                        className={`${styles.year_1} ${styles.imgs}`}
                                    />
                                    <img
                                        src="http://p2.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_02.png"
                                        className={`${styles.sunlight} ${styles.imgs}`}
                                        onClick={() => this.handleChangeStasrc('animationclick')}
                                    />
                                    <img
                                        src="http://p0.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_23.png"
                                        className={`${styles.ganzi} ${styles.imgs}`}
                                    />
                                    <a href={nav[0].url} target="_blank">
                                        <img src={nav[0].src} className={`${styles.tdjl} ${styles.imgs}`} />
                                    </a>
                                    <a
                                        href={nav[0].url}
                                        target="_blank"
                                        className={`${styles.tooltip_item} ${styles.item02}`}
                                        onClick={() => this.handleChangeStasrc('tdjlclick')}
                                    />
                                </div>
                                <div className={`${styles.section} ${styles.sec02}`} id="sec02">
                                    <img
                                        src="http://p0.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_04.png"
                                        className={styles.ren_h}
                                        onClick={() => this.handleChangeStasrc('animationclick')}
                                    />
                                    <img
                                        src="http://p3.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_05.png"
                                        className={styles.ren_z}
                                        onClick={() => this.handleChangeStasrc('animationclick')}
                                    />
                                    <img
                                        src="http://p2.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_26.png"
                                        className={styles.dianti}
                                    />
                                    <img
                                        src="http://p1.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_08.png"
                                        className={styles.ren_g}
                                        onClick={() => this.handleChangeStasrc('animationclick')}
                                    />
                                    <img
                                        src="http://p0.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_09.png"
                                        className={styles.ren_l}
                                        onClick={() => this.handleChangeStasrc('animationclick')}
                                    />
                                    <img
                                        src="http://p0.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_10.png"
                                        className={styles.ren_b}
                                    />
                                    <img
                                        src="http://p1.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_26a.png"
                                        className={styles.dianti2}
                                    />
                                    <a href={nav[1].url} target="_blank">
                                        <img src={nav[1].src} className={`${styles.gangw} ${styles.imgs}`} />
                                    </a>
                                    <a
                                        href={nav[1].url}
                                        target="_blank"
                                        className={`${styles.tooltip_item} ${styles.item01}`}
                                        onClick={() => this.handleChangeStasrc('gwjsclick')}
                                    />
                                    <a href={nav[4].url} target="_blank">
                                        <img src={nav[4].src} className={`${styles.renzai} ${styles.imgs}`} />
                                    </a>
                                    <Chip id="65008" type="struct" title="图片" groupName="校招首页" />
                                    <img src={imageInfo.src} className={`${styles.year_2} ${styles.imgs}`} />
                                    <a href={nav[2].url} target="_blank">
                                        <img src={nav[2].src} className={`${styles.xiaoz} ${styles.imgs}`} />
                                    </a>
                                    <a href={nav[3].url} target="_blank">
                                        <img src={nav[3].src} className={`${styles.guanf} ${styles.imgs}`} />
                                    </a>
                                    <a
                                        href={nav[4].url}
                                        target="_blank"
                                        className={`${styles.tooltip_item} ${styles.item03}`}
                                        onClick={() => this.handleChangeStasrc('rzfhclick')}
                                    />
                                    <a
                                        href={nav[3].url}
                                        target="_blank"
                                        className={`${styles.tooltip_item} ${styles.item04}`}
                                        onClick={() => this.handleChangeStasrc('gyfhclick')}
                                    />
                                    <a
                                        href={nav[2].url}
                                        target="_blank"
                                        className={`${styles.tooltip_item} ${styles.item05}`}
                                        onClick={() => this.handleChangeStasrc('gyxzclick')}
                                    />
                                </div>
                                <div className={`${styles.section} ${styles.sec03}`} id="sec03">
                                    <img
                                        src="http://p2.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_12.png"
                                        className={styles.huoche}
                                        onClick={() => this.handleChangeStasrc('animationclick')}
                                    />
                                    <img
                                        src="http://p1.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_13.png"
                                        className={styles.ren_lb}
                                    />
                                    <img
                                        src="http://p0.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_14.png"
                                        className={styles.ren_xl}
                                    />
                                    <img
                                        src="http://p3.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_16.png"
                                        className={styles.piao_1}
                                    />
                                    <img
                                        src="http://p2.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_17.png"
                                        className={styles.piao_2}
                                    />
                                    <img
                                        src="http://p2.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_18.png"
                                        className={styles.piao_3}
                                    />
                                    <a href="https://weibo.com/ifenghr?topnav=1&amp;wvr=6&amp;topsug=1" target="_blank">
                                        <img
                                            src="http://p1.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_19.png"
                                            className={styles.weib}
                                        />
                                    </a>
                                    <img
                                        src="http://p1.ifengimg.com/l/2018/6/f6a7e1c7d5c96be/r_20.png"
                                        className={styles.tengx}
                                    />
                                </div>
                            </div>
                            <div className={styles.maodi}>
                                <ul>
                                    <li
                                        className={scrollTop ? styles.current : ''}
                                        onClick={() => this.handleFixScroll(0)}
                                    />
                                    <li
                                        className={scrollMid ? styles.current : ''}
                                        onClick={() => this.handleFixScroll(768)}
                                    />
                                    <li
                                        className={scrollBottom ? styles.current : ''}
                                        onClick={() => this.handleFixScroll(1470)}
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Foot />
                    <Chip id="110040" type="struct" title="公用二维码信息" groupName="校招二维码" content={qrCodeInfo}>
                        <Qrcode />
                    </Chip>

                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
